export default "__VITE_ASSET__DYP4FWi0__"